import { Link } from "react-router-dom";
import { ArrowLeft, Brain } from "lucide-react";

export default function NotFoundPage() {
  return (
    <main className="min-h-[70vh] max-w-[1180px] mx-auto px-6 lg:px-12 pt-40 pb-24 flex flex-col items-start">
      <div className="font-mono text-[11px] tracking-[0.3em] uppercase text-[#38BDF8]">
        404 · Signal Lost
      </div>

      <h1 className="mt-5 font-display text-white text-[clamp(40px,7vw,84px)] leading-[1.02] font-medium tracking-tight headline-glow">
        This pathway hasn't been mapped.
      </h1>

      <p className="mt-5 text-[#CBD5E1] text-[17px] leading-relaxed max-w-xl">
        The page you're looking for either doesn't exist or hasn't been routed
        yet. Let's return to a known signal.
      </p>

      <div className="mt-9 flex flex-wrap items-center gap-3">
        <Link
          to="/"
          className="btn-glow inline-flex items-center gap-2 px-5 py-3 rounded-full bg-white text-[#020617] font-semibold text-[14px] hover:bg-[#BFDBFE]"
        >
          <ArrowLeft size={14} /> Back to home
        </Link>
        <Link
          to="/research"
          className="inline-flex items-center gap-2 px-5 py-3 rounded-full border border-white/15 text-white text-[14px] hover:border-[#38BDF8]/50"
        >
          <Brain size={14} className="text-[#38BDF8]" />
          Browse the science
        </Link>
      </div>

      {/* Ambient pulse */}
      <div
        className="pointer-events-none fixed top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 h-[640px] w-[640px] rounded-full opacity-25 nb-drift -z-10"
        style={{
          background:
            "radial-gradient(circle, rgba(56,189,248,0.35) 0%, transparent 60%)",
        }}
      />
    </main>
  );
}
